module.exports = __webpack_public_path__ + "img/2.9a0749fa.svg";